import React, { useEffect, useState } from "react";
import "./FilterModel.css";
import {
    FaHotel, FaGlassCheers, FaUmbrellaBeach, FaChalkboardTeacher, FaStar,
} from "react-icons/fa";
import { MdOutlineBedroomParent } from "react-icons/md";
import Slider from '@mui/material/Slider';




export default function FilterModal({ isOpen, onClose }) {
    const [min, setMin] = useState(900);
    const [max, setMax] = useState(5000);
    const [value, setValue] = useState([min, max]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const marks = [
        { value: value[0], label: `₹ ${value[0]}` },
        { value: value[1], label: `₹ ${value[1]}` }
    ];
    if (!isOpen) return null;

    return (
        <div className="lpfm-modal-backdrop" onClick={onClose}>
            <div className="lpfm-filter-modal" onClick={(e) => e.stopPropagation()}>

                <div className="lpfm-filter-header">
                    <h3>Filter</h3>
                    <button className="lpfm-close-btn" onClick={onClose}>×</button>
                </div>
                <div className="lpfm-modal-content">
                    {/* Header */}

                    {/* Type of Venue */}
                    <div className="lpfm-filter-section">
                        <h4>Type of Venue</h4>
                        <div className="lpfm-filter-options-venue lpfm-venue-icons">
                            <div className="f-m-type-of-venue"><FaHotel size={30} /> Hotel</div>
                            <div className="f-m-type-of-venue"><FaGlassCheers size={30} /> Clubs</div>
                            <div className="f-m-type-of-venue"><FaUmbrellaBeach size={30} /> Resorts</div>
                            <div className="f-m-type-of-venue"><FaChalkboardTeacher size={30} /> Conference Hall</div>
                            <div className="f-m-type-of-venue"><MdOutlineBedroomParent size={30} /> Guest House</div>
                        </div>
                    </div>

                    {/* Type of Packages */}
                    <div className="lpfm-filter-section">
                        <h4>Type of Packages</h4>
                        <div className="lpfm-filter-options-package lpfm-pills">
                            <div className="f-m-type-of-package-active">High Tea</div>
                            <div className="f-m-type-of-package">Café Menu</div>
                            <div className="f-m-type-of-package">Veg & Non-Veg</div>
                            <div className="f-m-type-of-package">Package A</div>
                        </div>
                    </div>

                    {/* Near By */}
                    <div className="lpfm-filter-section">
                        <h4>Near By</h4>
                        <div className="lpfm-range-bar">
                            <Slider
                                getAriaLabel={() => "Price range"}
                                value={value}
                                min={min}
                                max={max}
                                onChange={handleChange}
                                valueLabelDisplay="off"
                                marks={marks}
                            />
                            <p className="lpfm-price-range">Price Range:₹{value[0]}  - ₹{value[1]}</p>
                        </div>
                    </div>

                    {/* Review Stars */}
                    <div className="lpfm-filter-section">
                        <h4>Review</h4>
                        <div className="lpfm-filter-options lpfm-stars">
                            {[5, 4, 3, 2, 1].map((val) => (
                                <button key={val}>{val} <FaStar /></button>
                            ))}
                        </div>
                    </div>

                    {/* Sitting */}
                    <div className="lpfm-filter-section">
                        <h4>Sitting</h4>
                        <div className="lpfm-filter-options lpfm-pills">
                            <button>Indoor</button>
                            <button>Outdoor</button>
                        </div>
                    </div>

                    {/* City & Area */}
                    <div className="lpfm-filter-section">
                        <h4>City & Area</h4>
                        <div className="lpfm-city-area">
                            <p>Gurgaon</p>
                            <label><input type="checkbox" /> Sector 38</label>
                            <label><input type="checkbox" /> Area of Gurgaon</label>
                            <label><input type="checkbox" /> Option</label>
                            <p>City Name</p>
                            <label><input type="checkbox" /> Option</label>
                            <label><input type="checkbox" /> Option</label>
                            <label><input type="checkbox" /> Option</label>
                        </div>
                    </div>

                </div>
                    <div className="lpfm-filter-footer">
                        <button className="lpfm-clear-btn">Clear Filter</button>
                        <button className="lpfm-result-btn">Show 256 results</button>
                    </div>
            </div>
        </div>
    );
}
